




































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

interface navBarListType {
  name: string,
  path: string,
  icon?: string
}

@Component({
  name: 'Navs',
  components: {
  }
})
export default class Nav extends Vue {
  @Prop({ default: '' }) title?: string
  @Prop({ default: '' }) nextTitle?: string
  @Prop({ type: Array, default: () => { return [] } }) navBarList!: navBarListType[]

  private logo2 = require('../../../../assets/index-logo2.png')

  // private logoTitle2 = require('../../../../assets/logo-title4.png')

  // 点击索引
  private active: number | string = ''

  // 当路由跳转或者初始进入的时候设置点击状态
  @Watch('$route')
  setRouteActive (newValue: any): void {
    let actived: number | string = ''
    for (let i = 0; i < this.navBarList.length; i++) {
      const item = this.navBarList[i]
      if (item.path === newValue.path) {
        actived = i
        break
      }
    }
    this.active = actived
  }

  // 点击导航菜单
  clickNavBar (item: navBarListType): void {
    if (!/^http/.test(item.path)) {
      this.$router.push(item.path)
    } else {
      window.open(item.path)
    }
  }

  // h5模式下点击下拉导航菜单
  clickDropdown (item: string): void {
    if (!/^http/.test(item)) {
      this.$router.push(item)
    } else {
      window.open(item)
    }
  }
}
